import React from "react";

import store from "app/store";
import { st, Modal, Form, FormMessage, Button, FormControl, AgentCooperationsRepository } from "lib/index";

class NewAgentPrompt extends React.PureComponent {
  state = {
    agent: {
      email: "",
    },
    valid: false,
    submitLoading: false,
    error: null,
  };
  subscriptions = [];

  componentWillUnmount() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subscriptions.length = 0;
  }
  componentDidMount() {}
  handleAgentPropChange(prop, value) {
    const { agent } = this.state;
    const nextAgent = { ...agent, [prop]: value };
    this.setState({
      agent: nextAgent,
      valid: !!nextAgent.email,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { resolve } = this.props;
    const { agent, valid, submitLoading } = this.state;
    if (!valid || submitLoading) {
      return;
    }

    this.setState({ submitLoading: true, error: null });
    const create$ = AgentCooperationsRepository.create({
      agent_email: !this.props.isSupplier && agent.email,
      supplier_email: this.props.isSupplier && agent.email,
    }).subscribe(
      (coop) => {
        this.setState({ submitLoading: false });
        resolve(coop);
      },
      (error) => {
        st.api.handleError(error, store);
        this.setState({ submitLoading: false, error: st.api.findResponseErrorMessage(error) });
      }
    );
    this.subscriptions.push(create$);
  }

  render() {
    const { modalRef, resolve, ...props } = this.props;
    const { agent, valid, submitLoading, error } = this.state;

    return (
      <Modal closeIcon closeOnDimmerClick={false} size="small" ref={modalRef} {...props}>
        <Modal.Header>
          {this.props.isSupplier
            ? I18n.t("papp.agents.SuppliersListView.add_new")
            : I18n.t("papp.agents.NewAgentPrompt.title")}
        </Modal.Header>
        <Modal.Content>
          <Form onSubmit={this.handleSubmit.bind(this)} loading={submitLoading} error={!!error}>
            <FormMessage error={error} />

            <FormControl.InputFormGroup
              value={agent.email}
              onChange={this.handleAgentPropChange.bind(this, "email")}
              label={
                this.props.isSupplier
                  ? I18n.t("papp.suppliers.NewSupplierPrompt.email_label")
                  : I18n.t("papp.agents.NewAgentPrompt.email_label")
              }
              type="email"
              required
              autoFocus
            />

            <button type="submit" hidden disabled={!valid || submitLoading} />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button as="a" content={I18n.t("papp.common.cancel")} disabled={submitLoading} onClick={() => resolve()} />
          <Button
            as="a"
            primary
            floated="right"
            content={I18n.t("papp.agents.NewAgentPrompt.submit")}
            disabled={!valid || submitLoading}
            onClick={this.handleSubmit.bind(this)}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default function openNewAgentPrompt(props) {
  return st.createModal(NewAgentPrompt, props);
}



// WEBPACK FOOTER //
// ./src/modules/agents/NewAgentPrompt/NewAgentPrompt.jsx